import moment from "moment"

import { ImporteBodyTemplate } from "../../../../../Documentos/templates"
import {
  PERIODO_AMORTIZACION,
  TIPOS_AMORTIZACION,
} from "../../pages/PrestamoDetail/constants"
import "./styles.scss"

export const checkHasNotVerifiedRequirements = (
  flujoAprobaciones: $TSMigrationFixMe
) =>
  flujoAprobaciones.some(
    (element: $TSMigrationFixMe) => !element.todosLosRangos
  )

export const getBooleanIndefinido = (values: $TSMigrationFixMe) => {
  const { duracion, tipoImporteAmortizacion } = values
  return !duracion && !!tipoImporteAmortizacion
}

export const CURRENT_PAYMENT_TYPE = {
  COBRO: 1,
  PAGO: 2,
}

export const IMPORTE_TIPO = {
  1: "%",
  2: "€",
}

export const SELECTOR_TIPO = {
  1: "cuentaContableEmpresaId",
  2: "interes.cuentaContableEmpresaId",
}

export const IMPORTE_TIPO_SELECT_OPTIONS = [
  { label: IMPORTE_TIPO[1], value: 1 },
  { label: IMPORTE_TIPO[2], value: 2 },
]

export const TIPO_COMISION_SELECT_OPTIONS = (t: $TSMigrationFixMe) => [
  { label: `${t("impuestos.modalNew.types.opening")}`, value: 1 },
  { label: `${t("impuestos.modalNew.types.study")}`, value: 2 },
  { label: `${t("impuestos.modalNew.types.disposition")}`, value: 3 },
  { label: `${t("impuestos.modalNew.types.brokerage")}`, value: 4 },
  { label: `${t("impuestos.modalNew.types.other")}`, value: 5 },
]

export const PERIODO_AMORTIZACION_OPTIONS = (t: $TSMigrationFixMe) => [
  { label: PERIODO_AMORTIZACION(t)[1], value: 1 },
  { label: PERIODO_AMORTIZACION(t)[2], value: 2 },
]

export const TIPOS_AMORTIZACION_OPTIONS = (t: $TSMigrationFixMe) => [
  { label: TIPOS_AMORTIZACION(t)[1], value: 1 },
  { label: TIPOS_AMORTIZACION(t)[2], value: 2 },
]

export const contablesInteresConcebido = ["547", "534", "762"]

export const contablesInteresRecibido = ["662", "527", "528", "514"]

export const contablesComisionesConcebido = ["705", "754", "762"]

export const contablesComisionesRecibido = ["669", "626"]

export const contablesPrestamoConcebido = [
  "532",
  "542",
  "543",
  "544",
  "242",
  "252",
  "253",
  "254",
]

export const contablesPrestamoRecibido = ["170", "171", "520"]

export const filterFromCtasContables = (
  cuentasContables: $TSMigrationFixMe,
  cuentasSelected: $TSMigrationFixMe
) => {
  return cuentasContables.filter((cuenta: $TSMigrationFixMe) => {
    return cuentasSelected?.find(
      (cuentaSelected: $TSMigrationFixMe) =>
        cuentaSelected === cuenta?.cuentaContablePadreNumero
    )
  })
}

export const getCuentaContable = (
  cuentasContables: $TSMigrationFixMe,
  value: $TSMigrationFixMe
) => {
  return (
    cuentasContables?.filter(
      (cuentaContable: $TSMigrationFixMe) => cuentaContable.id === value
    )?.[0] || ""
  )
}

export const FORM_KEYS_RESET = [
  { key: "importe", value: "" },
  { key: "fecha", value: moment().format("YYYY-MM-DD") },
  { key: "descripcion", value: "" },
  { key: "periodoAmortizacion", value: 1 },
  { key: "concepto", value: "" },
  {
    key: "interes",
    value: {
      importe: null,
      cuentaContableEmpresaId: "",
    },
  },
  { key: "cuentaContableEmpresaId", value: "" },
  { key: "duracion", value: null },
  { key: "importeAmortizacion", value: null },
  { key: "empresaId", value: "" },
  { key: "camposPersonalizados", value: [] },
  { key: "comisiones", value: [] },
]

export const resetDefaultFormValues = (setFieldValue: $TSMigrationFixMe) =>
  FORM_KEYS_RESET.map(({ key, value }) => setFieldValue(key, value))

export const getDropdownAccounts = (backAccountList = []) => {
  return backAccountList?.map(({ id, iban, bic }) => ({
    label: iban,
    value: {
      id,
      iban,
      bic,
    },
  }))
}

export const setInititalAccountValues = (
  data: $TSMigrationFixMe,
  cuentasBancarias: $TSMigrationFixMe,
  setSelectedAccount: $TSMigrationFixMe,
  setFieldValue: $TSMigrationFixMe
) => {
  const cuenta = cuentasBancarias.filter(
    (cta: $TSMigrationFixMe) => cta?.id === data?.cuentaBancariaId
  )[0]
  const account = {
    iban: cuenta?.iban,
    id: cuenta?.id,
    bic: cuenta?.bic,
  }
  setSelectedAccount(account)
  setFieldValue("cuentaBancaria", {
    ...account,
    cuentaIdExterno: cuenta?.id,
    entidadBancariaId: cuenta?.id,
  })
}

export const TYPE_ADEUDO = {
  SIN_ADEUDO: "SIN_ADEUDO",
  CON_ADEUDO: "CON_ADEUDO",
}

export const handleChangeValueMessage = (
  importe: $TSMigrationFixMe,
  type: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return type === TYPE_ADEUDO.SIN_ADEUDO ? (
    <p className='mt-3 text confirm'>
      {t("prestamos.msg.ampliationOne")}{" "}
      <ImporteBodyTemplate
        importe={importe}
        className='boldText'
      />
    </p>
  ) : (
    <div className='m-3 text confirm d-flex flex-column'>
      <p>
        {t("prestamos.msg.ampliationOne")}{" "}
        <ImporteBodyTemplate
          importe={importe}
          className='boldText'
        />{" "}
        {t("prestamos.msg.ampliationTwo")}
      </p>
      <p>{t("prestamos.msg.apliationThree")}</p>
    </div>
  )
}
